import i18n from "../i18n";

const getLocalizedLogo = (path) => {
  return i18n.language === "ko" ? path : path.replace(/(\.[^.]+)$/, "-en$1");
};

const EN_MAPPED_LANGUAGES = new Set(["ja", "zh"]);

export const getLocalizedAssetPath = (path) => {
  if (i18n.language === "ko") {
    return path;
  }

  const suffix = EN_MAPPED_LANGUAGES.has(i18n.language)
    ? "en"
    : i18n.language;

  return path.replace(/(\.[^.]+)$/, `-${suffix}$1`);
};

export default getLocalizedLogo;
